import React, { Component, createRef } from 'react';
import classes from './OtpVerification.css';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import Message from '../../../../components/Message/Message';
import {COPY_SUCCESS_MESSAGE, COPY_FAILURE_MESSAGE, SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER,} from "../../../../shared/Constants";
import {
  isAccountDisabled,
} from "../../../../shared/utility";

class GenerateOTP extends Component {

  inputRef = createRef()

     state = {
        copyMessage:"",
        formError:"",
        phoneNumber: this.props.essoData?.phone?.number ?? '',
        countryCode: this.props.essoData?.phone?.countryCode ?? '',
        nameFormDetails: {
          firstName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                id: 'firstName',
                placeholder: 'first name',
                maxLength: 41
            },
            value: '',
            validation: {
                required: false,
                minlength: 2,
                maxlength: 40,
                specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
            },
            disabled: false,
            valid: true,
            touched: false,
            label: "First Name",
            inputType: "OneFifthInlineBlock",
          },
          lastName: {
              elementType: 'input',
              elementConfig: {
                  type: 'text',
                  id: 'lastName',
                  placeholder: 'last name',
                  maxLength: 41
              },
              value: '',
              validation: {
                  required: false,
                  minlength: 2,
                  maxlength: 40,
                  specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
              },
              valid: true,
              disabled: false,
              touched: false,
              label: "Last Name",
              inputType: "OneFifthInlineBlock",
          },
        },
        formDetails: {
          countryCode: {
            elementType: 'inputPhoneCode',
            elementConfig: {
                type: 'text',
                id: 'countryCode',
                minLength: 1,
                maxLength: 3,
                pattern: '[0-9]{1,3}',
                title:'Country Code can only contain numbers',
                // wrapperStyles: {zIndex: "-1"},
            },
            value: this.props.essoData?.phone?.countryCode?this.props.essoData.phone.countryCode:"",
            validation: {
                required: false,
                minlength: 1,
                maxlength: 3
            },
            disabled: false,
            valid: true,
            touched: false,
            label: "Country Code",
            inputType: "PhoneCode",
          },
          phoneNumber: {
              elementType: 'input',
              elementConfig: {
                  type: 'text',
                  id: 'phone',
                  minLength: 7,
                  maxLength: 15,
                  pattern: '[0-9]{1,15}',
                  title:'Phone Numbers can only contain numbers',
                  ref: this.inputRef
              },
              value: this.props.essoData?.phone?.number?this.props.essoData.phone.number:"",
              validation: {
                  required: false,
                  minlength: 7,
                  maxlength: 15
              },
              disabled: false,
              valid: true,
              touched: false,
              label: "Phone Number",
              // icon: <ContactVerificationIcon iconType={PHONE_VERIFICATION_ICON} 
              //     isEmailVerified={(this.props.member.essoData.email?this.props.member.essoData.email?.verified:false)}
              //     isSecondaryEmailVerified={(this.props.member.essoData.secondaryEmail?this.props.member.essoData.secondaryEmail?.verified:false)}
              //     isPhoneVerified={this.props.member.essoData.phone?.verified}/>,
              inputType: "phoneInput",
          },
        },
         otpForm: {
         otpTypeForm: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
                id: 'otpType',
                placeholder: 'Select One',
                options: [
                    // { value: 'Email', displayValue: 'Email' },
                    // ...(this.props.essoData.phone.number ? [{ value: 'Phone', displayValue: 'SMS' }] : []),
                    { value: 'Phone', displayValue: 'SMS' },
                    { value: 'Call', displayValue: 'Call' },
                ]        
            },
            value: 'Phone',
            touched: false,
            // label: "Send OTP to:",
            inputType: "OneThirdInlineOtpType",
        }
      }
     }
  componentDidUpdate(prevProps, prevState){    
  //   if (this.props.essoData.phone.number && prevState.otpForm['otpTypeForm'].elementConfig.options[1]?.value !== 'Phone') {
  //       let updatedForm = {...this.state.otpForm};
  //       const updatedFormElement = { ...updatedForm['otpTypeForm'].elementConfig.options[1] };
  //       updatedFormElement.value = this.props.essoData.phone.number?'Phone':'';
  //       updatedFormElement.displayValue = 'SMS';
  //       updatedForm['otpTypeForm'].elementConfig.options[1] = updatedFormElement;
  //       this.setState({otpForm: updatedForm});
  //   }

  //  if (this.props.essoData.phone.number === '' && prevState.otpForm['otpTypeForm'].elementConfig.options[1]?.value === 'Phone') {
  //       let updatedForm = {...this.state.otpForm};
  //       const updatedFormElement = { ...updatedForm['otpTypeForm'].elementConfig.options[1] };
  //       updatedFormElement.value = '';
  //       updatedFormElement.displayValue = '';
  //       updatedForm['otpTypeForm'].elementConfig.options[1] = updatedFormElement;
  //       this.setState({otpForm: updatedForm});
  //   }
  let updatedForm = {...this.state.formDetails};  
  let changed = false
    if(this.props.essoData.phone.number !== this.state.phoneNumber) {
        const updatedFormElement = { ...updatedForm['phoneNumber'] };
        updatedFormElement.value = this.props.essoData.phone.number;
        updatedForm['phoneNumber'] = updatedFormElement;
        changed = true
    }
    if(this.props.essoData.phone.countryCode !== this.state.countryCode) {
        const updatedFormElement = { ...updatedForm['countryCode'] };
        updatedFormElement.value = this.props.essoData.phone.countryCode;
        updatedForm['countryCode'] = updatedFormElement;
        changed = true
    }
    if(changed) {
      this.setState({formDetails: updatedForm, phoneNumber: this.props.essoData.phone.number, countryCode: this.props.essoData.phone.countryCode});
    }
  }
     inputChangedHandler =(event, inputIdentifier, stateType) => {

         let updatedForm = {...this.state[stateType]};

         const updatedFormElement = { ...updatedForm[inputIdentifier] };
         updatedFormElement.value = event.target.value;
         if(stateType==='formDetails' && inputIdentifier==='phoneNumber') {
          if(event.target.value.length<7 && event.target.value.length >0) {
            this.setState({formError: "Min 7 digits required"})
           } else {
            this.setState({formError: ""})
           }
         }
         if(inputIdentifier === 'otpTypeForm'){
          this.props.setOtpType(event.target.value);
        } else {
          this.props.setOtherFormDetails({[inputIdentifier]: event.target.value})
        }

         updatedForm[inputIdentifier] = updatedFormElement;

         updatedFormElement.touched = true;
         updatedForm[inputIdentifier] = updatedFormElement;

         this.setState({[stateType]: updatedForm});
     }

     handleOtpFlow = (event) => {
        event.preventDefault();
        if(this.props.disableTab === "-1") {
          return;
        }
        this.props.generateOtpToken(this.state.otpForm['otpTypeForm'].value, {
          firstName: this.state.nameFormDetails['firstName'].value,
          lastName: this.state.nameFormDetails['lastName'].value,
          countryCode: this.state.formDetails['countryCode'].value ?? this.props.essoData.phone?.countryCode ?? '',
          phoneNumber: this.state.formDetails['phoneNumber'].value ?? this.props.essoData.phone?.number ?? '',
        })
      }

      copyToClipBoard = async(e) => {
        // const v = this.copyToClipboard(message);
        // if (v === true) this.setState({copyMessage:COPY_SUCCESS_MESSAGE});
        // else this.setState({copyMessage:COPY_FAILURE_MESSAGE});
        e.preventDefault()
        try {
          if(this.inputRef && this.inputRef.current) {
            this.inputRef.current.select();
            await navigator.clipboard.writeText(this.state.formDetails.phoneNumber.value)
          }
        } catch (e) {

        }
    }

      render() {
        const formsElementsArray =[];
        const numberFormsElementsArray =[];
        const nameFormsElementsArray =[];

        for(let key in this.state.nameFormDetails) {
          nameFormsElementsArray.push({
                id: key,
                config: this.state.nameFormDetails[key]
            });
        }

      for(let key in this.state.formDetails) {
            numberFormsElementsArray.push({
                id: key,
                config: this.state.formDetails[key]
            });
        }

        for(let key in this.state.otpForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.otpForm[key]
            });
        }
        let generateOtpForm = (
          <form onSubmit={this.handleOtpFlow}>
            { [SESSION_SUPERUSER, SESSION_SUPERVISORUSER].includes(this.props.userType) && 
            <>
            <div>
            <label className={classes.RowLabel2}>For POA/AOR only:</label>
              {nameFormsElementsArray.map(formElement => (
                  <Input
                      key={formElement.id}
                      elementType={formElement.config.elementType}
                      elementConfig={formElement.config.elementConfig}
                      value={formElement.config.value}
                      invalid={!formElement.config.valid}
                      shouldValidate={formElement.config.validation}
                      touched={formElement.config.touched}
                      disabled={formElement.config.disabled}
                      label={formElement.config.label}
                      changed={(event) => this.inputChangedHandler(event, formElement.id, 'nameFormDetails')}
                      inputType={formElement.config.inputType}
                  />
                ))}
            </div>
            <div>
              <span className={classes.poaDisclaimer}><sup>*</sup>AORs are not permitted to request changes to the account. Only POAs are permitted to request changes. Escalate to L1.5 for eligible POA account updates.</span>
            </div>
            </>}
            <div className={classes.phoneNumberContainer}>
                {numberFormsElementsArray.map(formElement => (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    disabled={formElement.config.disabled}
                    label={formElement.config.label}
                    changed={(event) => this.inputChangedHandler(event, formElement.id, 'formDetails')}
                    inputType={formElement.config.inputType}
                    tabIndex={this.props.disableTab != undefined ? this.props.disableTab : 0}
                />
              ))}
              <button tabIndex={this.props.disableTab != undefined ? this.props.disableTab : 0} className={classes.copy_button} onClick={this.copyToClipBoard} disabled = {false}>Copy</button>
            </div>
            {this.state.formError && <Message msgType={"Error"} info={{message:this.state.formError}} />}
            <div className={classes.RowSplitOtp}>
            <label className={classes.RowLabel1}>Send OTP to:</label>
            {formsElementsArray.map(formElement => (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                disabled={formElement.config.disabled}
                label={formElement.config.label}
                changed={(event) => this.inputChangedHandler(event, formElement.id, 'otpForm')}
                inputType={formElement.config.inputType}
                tabIndex={this.props.disableTab != undefined ? this.props.disableTab : 0}
            />
          ))}
          <Button id="generateOtp" btnType="GenerateOTP" clicked={this.handleOtpFlow} disabled={this.state.formError || !(this.props.essoData.phone?.number ||
              this.state.formDetails['phoneNumber'].value
            ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
            || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
          }>Generate OTP</Button>
          </div>
          </form>
        );

        return (
            <React.Fragment>
              {generateOtpForm}
            </React.Fragment>
        );
      }

}

export default GenerateOTP;
